import React from 'react';
import { images } from '../data/content';
export function Hero() {
  return <section className="px-6 pb-4 pt-10" data-id="element-79" data-mp="ejwfyzd2ht1i">
      <h1 className="text-center font-display text-[29px] font-semibold leading-[1.28] tracking-[-0.015em] text-ink-900" data-id="element-80" data-mp="ej4n3wauu9ex">
        Con soli <span className="text-ink-700" data-id="element-81" data-mp="9ipc3be1pe04">10 minuti al giorno</span>, tuo figlio{' '}
        <span className="text-forest-600" data-id="element-82" data-mp="4n9wadwh9812">molla il telefono</span> e inizia a costruire con le sue
        mani. Oltre <span className="accent-underline text-gold-500" data-id="element-83" data-mp="128pg780q2n1x">365 progetti</span> da fare in
        casa.
      </h1>

      <div className="mt-8" data-id="element-84" data-mp="x8jndoipuui9">
        <img src={images.heroBox} alt="Scatola del Mega Kit Piccolo Ingegnere aperta, piena di progetti di cartone, schede e materiali da costruire" className="mx-auto w-full max-w-[420px]" width={840} height={840} loading="eager" fetchPriority="high" decoding="sync" data-id="element-85" data-mp="saruosa8z4d0" />
      </div>
    </section>;
}